import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Over_1 from '../../../assets/images/our-products/01.png';
import Over_2 from '../../../assets/images/our-products/02.png';
import Over_3 from '../../../assets/images/our-products/03.png';
import Over_4 from '../../../assets/images/our-products/04.png';
import Over_5 from '../../../assets/images/our-products/05.png';
import Over_6 from '../../../assets/images/our-products/06.png';

const products = {
    "Best Seller": [
        {
            id: 1,
            image: Over_1,
            title: 'Mini Chair Still Stands',
            price: '$80.00',
            rating: 4.8,
            reviews: 1248,
            discount: '-20%',
        },
        {
            id: 2,
            image: Over_2,
            title: 'Wooden Sofa mini',
            price: '$120.00',
            rating: 4.8,
            reviews: 1248,
        },
        {
            id: 3,
            image: Over_3,
            title: 'Spring Table',
            price: '$260.00',
            rating: 4.8,
            reviews: 1248,
        },
        {
            id: 4,
            image: Over_4,
            title: 'Sofa Jeeper With Wooden',
            price: '$80.00',
            rating: 4.8,
            reviews: 1248,
        },
        {
            id: 5,
            image: Over_5,
            title: 'Wooden Table mini',
            price: '$120.00',
            rating: 4.8,
            reviews: 1248,
        },
        {
            id: 6,
            image: Over_6,
            title: 'Mini Table Premium',
            price: '$260.00',
            rating: 4.8,
            reviews: 1248,
        },
    ],
    "New Arrivals": [
        {
            id: 7,
            image: Over_1,
            title: 'Mini Chair Still Stands',
            price: '$80.00',
            rating: 4.8,
            reviews: 1248,
            discount: '-20%',
        },
        {
            id: 8,
            image: Over_2,
            title: 'Wooden Sofa mini',
            price: '$120.00',
            rating: 4.8,
            reviews: 1248,
        },
        {
            id: 9,
            image: Over_3,
            title: 'Spring Table',
            price: '$260.00',
            rating: 4.8,
            reviews: 1248,
        },
        {
            id: 10,
            image: Over_4,
            title: 'Sofa Jeeper With Wooden',
            price: '$80.00',
            rating: 4.8,
            reviews: 1248,
        },
        {
            id: 11,
            image: Over_5,
            title: 'Wooden Table mini',
            price: '$120.00',
            rating: 4.8,
            reviews: 1248,
        },
        {
            id: 12,
            image: Over_6,
            title: 'Mini Table Premium',
            price: '$260.00',
            rating: 4.8,
            reviews: 1248,
        },
    ],
};

const OverProdect = () => {
    const [category, setCategory] = useState("Best Seller");

    const handleTabChange = (tab) => {
        setCategory(tab);
    };

    return (
        <section id="our-products" className="our-products-main-block">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="section">
                            <h2 className="section-heading-four">Our Products</h2>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-6">
                        <ul
                            className="our-product-nav-pills nav nav-pills float-start float-lg-end"
                            id="pills-tab-product"
                            role="tablist"
                        >
                            <li className="nav-item" role="presentation">
                                <Link
                                    className={`nav-link ${category === "Best Seller" ? "active" : ""}`}
                                    onClick={() => handleTabChange("Best Seller")}
                                    id="pills-tab5-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-tab5"
                                    title=""
                                    role="tab"
                                    aria-controls="pills-tab5"
                                    aria-selected={category === "Best Seller"}
                                >
                                    Best Seller
                                </Link>
                            </li>
                            <li className="nav-item" role="presentation">
                                <Link
                                    className={`nav-link ${category === "New Arrivals" ? "active" : ""}`}
                                    onClick={() => handleTabChange("New Arrivals")}
                                    id="pills-tab6-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-tab6"
                                    title=""
                                    role="tab"
                                    aria-controls="pills-tab6"
                                    aria-selected={category === "New Arrivals"}
                                >
                                    New Arrivals
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="tab-content" id="myTabContent">
                        <div
                            className={`tab-pane fade ${category === 'Best Seller' ? 'show active' : ''}`}
                            id="pills-tab5"
                            role="tabpanel"
                            aria-labelledby="pills-tab5-tab"
                        >
                            <div className="row">
                                {products["Best Seller"].map(product => (
                                    <div key={product.id} className="col-lg-4 col-md-6">
                                        <div className="our-product-block">
                                            <div className="featured-product-img">
                                                {product.discount && <span className="badge badge-four">{product.discount}</span>}
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={product.image}
                                                        className="img-fluid"
                                                        alt={product.title}
                                                    />
                                                </Link>
                                                <div className="our-product-dtls">
                                                    <div className="trending-product-dtls">
                                                        <div className="row">
                                                            <div className="col-lg-8 col-8">
                                                                <h5 className="trending-product-title">
                                                                    <Link to="/ShopDetails" title="">
                                                                        {product.title}
                                                                    </Link>
                                                                </h5>
                                                                <p className="rate">{product.price}</p>
                                                            </div>
                                                            <div className="col-lg-4 col-4">
                                                                <div className="trending-product-rating">
                                                                    <span className="badge badge-two">
                                                                        {product.rating}
                                                                        <i className="flaticon-star" />
                                                                    </span>
                                                                    <p className="review">({product.reviews})</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="col-lg-12">
                                    <div className="our-product-btn text-center">
                                        <Link to="/Shop" title="" className="btn btn-primary-four">
                                            See All Products
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className={`tab-pane fade ${category === 'New Arrivals' ? 'show active' : ''}`}
                            id="pills-tab6"
                            role="tabpanel"
                            aria-labelledby="pills-tab6-tab"
                        >
                            <div className="row">
                                {products["New Arrivals"].map(product => (
                                    <div key={product.id} className="col-lg-4 col-md-6">
                                        <div className="our-product-block">
                                            <div className="featured-product-img">
                                                {product.discount && <span className="badge badge-four">{product.discount}</span>}
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={product.image}
                                                        className="img-fluid"
                                                        alt={product.title}
                                                    />
                                                </Link>
                                                <div className="our-product-dtls">
                                                    <div className="trending-product-dtls">
                                                        <div className="row">
                                                            <div className="col-lg-8 col-8">
                                                                <h5 className="trending-product-title">
                                                                    <Link to="/ShopDetails" title="">
                                                                        {product.title}
                                                                    </Link>
                                                                </h5>
                                                                <p className="rate">{product.price}</p>
                                                            </div>
                                                            <div className="col-lg-4 col-4">
                                                                <div className="trending-product-rating">
                                                                    <span className="badge badge-two">
                                                                        {product.rating}
                                                                        <i className="flaticon-star" />
                                                                    </span>
                                                                    <p className="review">({product.reviews})</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="col-lg-12">
                                    <div className="our-product-btn text-center">
                                        <Link to="/Shop" title="" className="btn btn-primary-four">
                                            See All Products
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OverProdect;